import {useGetAllVehiclesQuery, VehicleSelectorProps, vehiclesSelector} from "@ots-frontend/ots-data";
import {BaseVehicleSelect, BaseVehicleSelectProps} from "./BaseVehicleSelect";
import {useMemo} from "react";

export type VehicleSelectProps = Omit<BaseVehicleSelectProps, "entities" | "loading"> & {
  selector?: VehicleSelectorProps
}

export const VehicleSelect = (props: VehicleSelectProps) => {
  const { selector, ...rest } = props;

  const selectVehicles = useMemo(() => {
    return vehiclesSelector();
  }, []);

  const { vehicles, isLoading } = useGetAllVehiclesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      vehicles: selectVehicles(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseVehicleSelect entities={vehicles} loading={isLoading} {...rest} />;
};
